<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                创建试卷
                <div class="operationBtn">
                  <el-button type="primary" @click="createPaper"
                    >立即创建</el-button
                  >
                  <el-button @click="cancelCreate">取消</el-button>
                </div>
              </h3>
              <el-divider></el-divider>
              <el-form ref="form" :model="form" label-width="5rem">
                <el-form-item label="试卷名称">
                  <el-col :span="11">
                    <el-input v-model="form.name"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="描述信息">
                  <el-input
                    type="textarea"
                    v-model="form.desc"
                    rows="8"
                  ></el-input>
                </el-form-item>
              </el-form>
              <h4>
                <el-button @click="goAddCase"> + 添加试题 </el-button>
              </h4>
              <el-divider></el-divider>
              <keep-alive>
                <div class="caseListWrapper">
                  <div
                    v-for="caseItem in caseList"
                    :key="caseItem.id"
                    class="caseItem"
                  >
                    <div class="caseInfo">
                      <div class="caseName">{{ caseItem.name }}</div>
                      <div class="caseDesc">试题描述：{{ caseItem.desc }}</div>
                    </div>
                    <div class="caseOperation" @click="deleteCase(caseItem)">
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                </div>
              </keep-alive>
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 优化点
import Leftbar from "@/components/newComponent/Leftbar";
import { paperCreate } from "@/api/paper";
import {
  taskTypeFilter,
  taskStateFilter,
  taskBadgeFilter,
} from "@/utils/filter";

export default {
  components: {
    Leftbar,
  },
  name: "taskCreate",
  bodyClass: "index-page",
  props: {},
  filters: {
    taskTypeFilter,
    taskStateFilter,
    taskBadgeFilter,
  },
  data() {
    return {
      value1: [],
      form: {
        name: "",
        desc: "",
      },
      caseList: [],
    };
  },
  mounted() {
    this.caseList = this.caseList.concat(
      this.$route.params.selectedCaseList || [],
    );
  },
  methods: {
    createPaper() {
      const caseIdList = this.caseList.map((v) => v.id);
      paperCreate(
        this.form.name,
        this.form.desc,
        caseIdList,
        localStorage.getItem("uid"),
        localStorage.getItem("email"),
      ).then((res) => {
        if (res.id) {
          this.$message({
            type: "success",
            message: "试卷创建成功",
          });
          this.$router.push("/paper");
        }
      });
    },
    cancelCreate() {
      this.$router.push("/paper");
    },
    deleteCase(caseItem) {
      this.caseList.map((cur, index) => {
        if (cur.id == caseItem.id) {
          this.caseList.splice(index, 1);
        }
      });
    },
    goAddCase() {
      this.$router.push({
        name: "case",
        params: {
          selectedCaseList: this.caseList,
        },
      });
    },
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
  },

  beforeDestroy() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}

.operationBtn {
  float: right;
}

.caseItem {
  height: 100px;
  width: 100%;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.12),
    0 0 6px rgba(0, 0, 0, 0.04);
  display: flex;
  margin-bottom: 10px;
  align-items: center;

  .caseInfo {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    // border: 1px green solid;
    padding-left: 20px;
  }

  .caseOperation {
    width: 100px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
